import { ReactionType } from '../../../../generated/graphql';

export const getEmojiTypesRows = () => {
  return [
    [
      ReactionType.Heart,
      ReactionType.Rocket,
      ReactionType.Goat,
      ReactionType.Fire,
      ReactionType.Tada,
    ],
    [
      ReactionType.ThumbsUp,
      ReactionType.Horns,
      ReactionType.Clap,
      ReactionType.Muscle,
      ReactionType.RaisedHands,
    ],
    [
      ReactionType.OpenMouth,
      ReactionType.Joy,
      ReactionType.Cry,
      ReactionType.Disappointed,
      ReactionType.FaceHearts,
    ],
  ] as Array<Array<ReactionType>>;
};
